// extracted by mini-css-extract-plugin
export var chevron = "_kq-2";
export var chevronRotated = "_kq-3";
export var header = "_kq-1";
export var section = "_kq-0";